(function () {

    'use strict';

    angular.module('iplusjs.filepopup', [
        'lodash',
        'modernizr',
        'angulartics',
        'iplusjs.config',
        'iplusjs.utils.misc',
        'iplusjs.utils.device',
        'iplusjs.loadingIndicator',
        'iplusjs.utils.html'
    ])
        .component('iplusjsPopupBlocker', {
            bindings: {
                file: '<ipbpFile'
            },
            templateUrl: 'common/filepopup/popupBlocker.html',
            controller: PopupBlockerController,
            controllerAs: 'popupBlockerVm'
        }).service('FilePopupService', FilePopupService);

    PopupBlockerController.$inject = [
        'FilePopupService',
        'modernizr',
        'lodash',
        '$analytics'
    ];

    function PopupBlockerController(FilePopupService, modernizr, _, $analytics) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onChange = onChange;

        vm.download = modernizr.adownload;
        vm.close = close;

        function onInit() {
            activate();
        }

        function onChange(file) {
            if (file) {
                vm.isVisible = true;
                vm.file = file;
            } else {
                vm.isVisible = false;
                vm.file = {};
            }
        }

        function activate() {
            vm.file = vm.file || {};
            vm.isVisible = !!vm.file;

            if (vm.isVisible && vm.file) {
                $analytics.eventTrack('link', {
                    target: 'Popup-Blocker'
                });
            }
        }
        function close() {
            vm.isVisible = false;
            FilePopupService.removeBlockedFile();
        }
    }

    FilePopupService.$inject = [
        '$rootScope',
        '$window',
        '$timeout',
        '$anchorScroll',
        'lodash',
        'AppConfig',
        'MiscUtilsService',
        'LoadingIndicatorService',
        'HtmlUtilsService'
    ];
    function FilePopupService($rootScope, $window, $timeout, $anchorScroll, _, AppConfig, MiscUtilsService, LoadingIndicatorService, HtmlUtilsService) {
        var that = this,
            blockedFile = null,
            fileUrl,
            downloadLink;

        $rootScope.$on('iplusjs:openFile', function ($event, file, popup, options) {
            var timeout = 0;

            options = options || {};

            if (_.isEmpty(file)) {
                return;
            }

            if ($window.navigator.msSaveOrOpenBlob) {
                $rootScope.$broadcast('iplusjs:openFileReady');
                $window.navigator.msSaveOrOpenBlob(file.blob, file.name);
            } else {
                if (MiscUtilsService.existsAdobeAcrobatPlugin() && (file.mimeType === 'application/pdf' || file.type === 'report')) {
                    if (file.fileUrl) {
                        fileUrl = file.fileUrl;
                        timeout = AppConfig.APP.debounce.pdfReport;
                    } else {
                        downloadLink = angular.element('<a style="display: none;"></a>');
                        downloadLink.attr('href', file.blobUrl);
                        downloadLink.attr('download', file.name);
                        $window.document.body.appendChild(downloadLink[0]);
                        downloadLink[0].click();
                        $window.document.body.removeChild(downloadLink[0]);
                        $rootScope.$broadcast('iplusjs:openFileReady');
                        return;
                    }
                } else {
                    if (!file.blobUrl) {
                        timeout = AppConfig.APP.debounce.pdfReport;
                    }

                    fileUrl = file.blobUrl || file.fileUrl;
                }

                if (timeout) {
                    LoadingIndicatorService.addInProgress();
                }

                $timeout(function () {
                    if (HtmlUtilsService.isWindowClosed(popup)) {
                        popup = HtmlUtilsService.openPopup(fileUrl, {
                            name: file.bezeichnung,
                            popupOptions: options.popupOptions || 'scrollbars=yes,resizable=yes,menubar=yes,status=yes',
                            width: options.width || 720,
                            height: options.height || 610
                        });
                    } else {
                        popup.location.href = fileUrl;
                    }

                    if (HtmlUtilsService.isWindowClosed(popup)) {
                        that.setBlockedFile(file);
                    }

                    if (timeout) {
                        LoadingIndicatorService.removeInProgress();
                    }

                    $rootScope.$broadcast('iplusjs:openFileReady');
                }, timeout);
            }
        });

        that.hasBlockedFile = false;

        that.setBlockedFile = setBlockedFile;
        that.getBlockedFile = getBlockedFile;
        that.removeBlockedFile = removeBlockedFile;
        that.hasBlockedPopup = hasBlockedPopup;
        function setBlockedFile(file) {
            blockedFile = file;
            that.hasBlockedFile = !_.isEmpty(file);

            if (that.hasBlockedFile) {
                $anchorScroll('anchorGlobalAlert');
            }
        }
        function getBlockedFile() {
            return blockedFile;
        }

        function removeBlockedFile() {
            that.hasBlockedFile = false;
            blockedFile = null;
        }

        function hasBlockedPopup() {
            return that.hasBlockedFile;
        }
    }
})();
